module.exports = __webpack_public_path__ + "static/img/case1.0ce1e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/case1.jpg
// module id = mbBL
// module chunks = 1